import { ProfileForm } from "../../components/profileForm";
import { Header } from "../../../shared/components/header";
import { Profile as ProfileType } from "../../../models/profile";

export const Profile = ({ navigation }) => {
  const initialState: ProfileType = {
    organizationId: 0,
    organizationName: "",
    userProfileId: "",
    email: "",
    name: "ss",
    lastName: "",
    dateOfBirth: null,
    annualIncome: 0,
    socialSecurityIncome: 0,
    creditScore: 0,
    retirementDate: null,
    firstFinancialGoal: "",
    address: "",
    city: "",
    state: "0",
    zipCode: "",
    workPhone: "",
    mobile: "",
    secondaryEmail: "",
    yearsInTheCompany: 0,
    profilePicture: "",
    maritalStatusId: 0,
    hasSpouse: false,
    spouseAnnualIncome: 0,
    spouseRetirementAge: 0,
    noChildren: 0,
    educatorId: "",
    genderId: 0,
    employeeId: "",
    enabled: false,
    participantProfileLink: "",
    assessmentCompleted: false,
    openedParticipantProfileLink: false,
    lastActivity: "",
    participantProfileId: "",
    profilePicturePath: "",
    smsSettingEnable: false,
    inflation: 0,
    hasActiveStripeAccount: false,
    isPremium: false,
  };

  return (
    <Header navigation={navigation}>
      <ProfileForm profileState={initialState} />
    </Header>
  );
};
